import { trustPoints, trustStats } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";

export default function TrustBar() {
  return (
    <section className="border-y border-background-200/80 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-14">
        <Reveal className="grid grid-cols-2 gap-x-6 gap-y-8 md:grid-cols-4">
          {trustStats.map((stat, index) => (
            <div
              key={stat.label}
              className={index > 0 ? "md:border-l md:border-background-300/70 md:pl-6" : ""}
            >
              <p
                className={`font-heading text-3xl font-bold md:text-4xl ${
                  index === 0 ? "text-accent-600" : "text-foreground-950"
                }`}
              >
                {stat.value}
              </p>
              <p className="mt-1.5 text-xs text-foreground-600 md:text-[13px]">{stat.label}</p>
            </div>
          ))}
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-3 border-t border-background-300/70 pt-8 sm:grid-cols-2 lg:grid-cols-4 md:gap-4">
          {trustPoints.map((point, index) => (
            <Reveal key={point.title} delay={index * 70}>
              <div className="flex h-full gap-3 rounded-lg border border-background-300/70 bg-background-50 p-4">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-900">
                  <i className={`${point.icon} text-base`} aria-hidden="true" />
                </span>
                <div>
                  <h3 className="text-sm font-medium text-foreground-950">{point.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{point.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}